import { useEffect, useState } from "react";
import api from "../api/api";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

export default function OrdersPlanning() {
  const [grouped, setGrouped] = useState({});

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await api.get("/orders");

      const filtered = res.data.filter((o) =>
        [1, 2].includes(Number(o.status_id))
      );

      const groups = {};

      filtered.forEach((order) => {
        const date = formatDate(order.service_date);

        if (!groups[date]) groups[date] = [];
        groups[date].push(order);
      });

      setGrouped(groups);
    } catch (err) {
      console.error("Błąd pobierania:", err);
    }
  };

  const btn = {
    primary:
      "bg-blue-600 text-white text-sm font-semibold px-4 py-1.5 rounded hover:bg-blue-700 transition shadow-sm",
    success:
      "bg-green-600 text-white text-sm font-semibold px-4 py-1.5 rounded hover:bg-green-700 transition shadow-sm",
    danger:
      "bg-red-500 text-white text-sm font-semibold px-4 py-1.5 rounded hover:bg-red-600 transition shadow-sm",
    ghost:
      "bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded hover:bg-gray-300 transition",
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const handleDragEnd = (result, date) => {
    if (!result.destination) return;

    const items = Array.from(grouped[date]);

    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setGrouped((prev) => ({
      ...prev,
      [date]: items,
    }));
  };

  const handleSchedule = async (date) => {
    const dateOrders = grouped[date].map((o, index) => ({
      id: o.id,
      priority: index + 1,
    }));

    try {
      await api.put("/orders/schedule", {
        orders: dateOrders,
        setStatus: true,
      });

      fetchOrders();
    } catch (err) {
      console.error("Błąd planowania:", err);
    }
  };

  if (Object.keys(grouped).length === 0) {
    return <div className="p-6 text-gray-600">Brak zleceń do zaplanowania</div>;
  }

  return (
    <div className="p-2 space-y-10">
      {Object.keys(grouped).map((date) => (
        <div
          key={date}
          className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden"
        >
          <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
            <h2 className="text-bg font-medium text-gray-600">
              Data realizacji:{" "}
              <span className="text-gray-800 font-bold">{date}</span>
            </h2>

            <button onClick={() => handleSchedule(date)} className={btn.primary}>
              Zaplanuj
            </button>
          </div>

          <DragDropContext onDragEnd={(result) => handleDragEnd(result, date)}>
            <Droppable droppableId={date}>
              {(provided) => (
                <div className="overflow-x-auto">
                  <table
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="w-full text-sm"
                  >
                    <thead className="bg-gray-100 text-gray-600 border-b border-gray-200">
                      <tr className="text-left text-sm font-semibold">
                        <th className="px-6 py-3">Nr</th>
                        <th className="px-6 py-3">Nazwa</th>
                        <th className="px-6 py-3">Miasto</th>
                        <th className="px-6 py-3">Ulica</th>
                        <th className="px-6 py-3">Kod</th>
                        <th className="px-6 py-3">Ilość</th>
                        <th className="px-6 py-3">Priorytet</th>
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100">
                      {grouped[date].map((o, index) => (
                        <Draggable
                          key={o.id}
                          draggableId={String(o.id)}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`transition-colors ${snapshot.isDragging
                                  ? "bg-blue-50 shadow-sm"
                                  : "hover:bg-gray-50"
                                }`}
                            >
                              <td className="px-6 py-3 text-gray-700">{o.id}</td>
                              <td className="px-6 py-3 font-medium text-gray-800">
                                {o.contractor_name}
                              </td>
                              <td className="px-6 py-3 text-gray-600">{o.city}</td>
                              <td className="px-6 py-3 text-gray-600">{o.street}</td>
                              <td className="px-6 py-3 text-gray-600">{o.zip_code}</td>
                              <td className="px-6 py-3 text-gray-700 font-medium">
                                {o.quantity}
                              </td>
                              <td className="px-6 py-3 text-gray-600">{o.priority}</td>
                            </tr>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </tbody>
                  </table>
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      ))}
    </div>
  );
}